import { Asset } from '../types';

const TRUSTED_US_EXCHANGES = new Set(['US', 'NYSE', 'NASDAQ', 'NASDAQGS', 'NASDAQGM', 'NASDAQCM', 'NYSEARCA', 'AMEX', 'ARCA']);

const isUkExchange = (value?: string) => {
    const normalized = (value || '').trim().toUpperCase();
    if (!normalized) return false;
    return normalized.includes('LSE') || normalized.includes('XLON') || normalized.includes('LON') || normalized.includes('LONDON');
};

const isTrustedUsExchange = (value?: string) => {
    const normalized = (value || '').trim().toUpperCase();
    if (!normalized) return false;
    return TRUSTED_US_EXCHANGES.has(normalized) || normalized.includes('NYSE') || normalized.includes('NASDAQ');
};

const hasUsdWithoutLseEvidence = (asset: Pick<Asset, 'exchange' | 'priceCurrency' | 'quoteCurrency'>) => {
    const priceCurrency = String(asset.priceCurrency || '').trim().toUpperCase();
    const quoteCurrency = String(asset.quoteCurrency || '').trim().toUpperCase();
    return (priceCurrency === 'USD' || quoteCurrency === 'USD') && !isUkExchange(asset.exchange);
};

type QuoteRequestAsset = Pick<Asset, 'symbol' | 'dataProviderId' | 'exchange' | 'priceCurrency' | 'quoteCurrency' | 'instrumentId'> & { providerKey?: string };

export const buildQuoteProviderRequest = (asset: QuoteRequestAsset) => {
    const instrumentId = String(asset.instrumentId || '').trim();
    if (instrumentId) {
        return { source: 'instrument' as const, providerValue: instrumentId };
    }

    const explicitProviderKey = String(asset.providerKey || '').trim();
    const providerId = String(asset.dataProviderId || explicitProviderKey || '').trim().toUpperCase();
    const symbol = String(asset.symbol || '').trim().toUpperCase();
    const fallback = providerId || symbol;
    if (!fallback) return null;

    if (fallback.includes(':')) {
        const [source, value] = fallback.split(':', 2);
        if ((source === 'FMP' || source === 'EODHD') && value) {
            return { source: source.toLowerCase() as 'fmp' | 'eodhd', providerValue: value.trim().toUpperCase() };
        }
    }

    if (fallback.includes('.')) {
        return { source: 'eodhd' as const, providerValue: fallback };
    }

    if (isTrustedUsExchange(asset.exchange) || hasUsdWithoutLseEvidence(asset)) {
        return { source: 'fmp' as const, providerValue: fallback };
    }

    if (isUkExchange(asset.exchange)) {
        return { source: 'eodhd' as const, providerValue: `${fallback}.LSE` };
    }

    return { source: 'fmp' as const, providerValue: fallback };
};
